import { Outlet } from "react-router-dom";

import { CommunityRail } from "./community-rail";
import { useCommunityRealtime } from "../realtime";

/** Two-pane layout: vertical community icon rail + the active app page
 *  (community page, create flow, discovery, etc.). Also mounts the
 *  community realtime hook so messages stream in live for whichever
 *  channel is currently focused.
 *
 *  Rail is hidden via responsive class on small screens — the mobile
 *  shell renders its own rail inside the left drawer. */
export function CommunitiesLayout() {
  useCommunityRealtime();
  return (
    <div className="flex h-full w-full bg-[#0b0d0f] text-[#e7e9ea]">
      <div className="hidden sm:flex">
        <CommunityRail />
      </div>
      <Outlet />
    </div>
  );
}
